"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Service = void 0;
var Service = /** @class */ (function () {
    function Service(data) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.price = data.price * 1;
        this.specific_tax = data.specific_tax;
    }
    Service.prototype.toJson = function () {
        return __assign({}, this);
    };
    return Service;
}());
exports.Service = Service;
